(function () {
  function bind(g) {
    if (g.dataset.jiReorderBound) return;
    g.dataset.jiReorderBound = '1';

    var ids = (g.getAttribute('data-ji-variant-media') || '').split(',').filter(Boolean);
    if (!ids.length) return;

    var carousel = g.querySelector('media-carousel');
    var mobileQuery = window.matchMedia('(max-width: 699px)');

    function getSlides() {
      return Array.prototype.slice.call(g.querySelectorAll('.product-gallery__media'));
    }

    function getThumbs() {
      return Array.prototype.slice.call(g.querySelectorAll('.product-gallery__thumbnail'));
    }

    function getDots() {
      return Array.prototype.slice.call(g.querySelectorAll('page-dots:not(.product-gallery__thumbnail-list) .tap-area'));
    }

    function clearOrder(list) {
      for (var i = 0; i < list.length; i++) {
        list[i].style.order = '';
      }
    }

    function clearMobileOrder() {
      clearOrder(getSlides().concat(getThumbs()).concat(getDots()));
    }

    function setOrderAndCurrent(list, selIdx, setCurrent) {
      for (var i = 0; i < list.length; i++) {
        list[i].style.order = (i === selIdx) ? '-1' : '';
        if (setCurrent) {
          list[i].setAttribute('aria-current', (i === selIdx) ? 'true' : 'false');
        }
      }
    }

    function reorderDesktop() {
      var slides = getSlides();
      var thumbs = getThumbs();
      var dots = getDots();
      var selIdx = -1;

      for (var i = 0; i < slides.length; i++) {
        var id = slides[i].getAttribute('data-media-id');
        if (ids.indexOf(id) !== -1 && !slides[i].hasAttribute('hidden')) {
          selIdx = i;
          break;
        }
      }

      if (selIdx === -1) return;

      setOrderAndCurrent(slides, selIdx, false);
      setOrderAndCurrent(thumbs, selIdx, true);
      setOrderAndCurrent(dots, selIdx, true);

      if (carousel) {
        try {
          carousel.scrollTo({ left: 0, behavior: 'auto' });
        } catch (e) {
          carousel.scrollLeft = 0;
        }
      }
    }

    function run() {
      if (mobileQuery.matches) {
        clearMobileOrder();
        return;
      }

      reorderDesktop();
      setTimeout(reorderDesktop, 150);
      setTimeout(reorderDesktop, 400);
    }

    run();

    new MutationObserver(function () {
      window.requestAnimationFrame(run);
    }).observe(g, { attributes: true, attributeFilter: ['filtered-indexes'] });

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', run);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(run);
    }
  }

  function init() {
    document.querySelectorAll('product-gallery[data-ji-qty]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
